import { useCallback } from "react";
import { axiosPublic } from "../api/axiosCustom";
import { apiBaseUrl } from "../utils/constants/env.constants";
import { RENEW_ACCESS_TOKEN } from "../utils/constants";
import { handleLogout } from "../utils/helperFunctions";
import useZustandStore from "../zustandStore/useZustandStore";

let refreshPromise = null;

const useRefreshToken = () => {
  const setOpenSessionExpiredModal = useZustandStore(
    (val) => val?.setOpenSessionExpiredModal
  );

  const refresh = useCallback(async () => {
    if (refreshPromise) return refreshPromise;

    const url = apiBaseUrl + RENEW_ACCESS_TOKEN;
    refreshPromise = axiosPublic
      .post(url, {}, { withCredentials: true })
      .then(({ status }) => status === 200)
      .catch((err) => {
        const status = err?.response?.status;
        if (status === 400) {
          setOpenSessionExpiredModal(true);
          handleLogout({ type: "refresh_token" });
        }
        return false;
      })
      .finally(() => {
        refreshPromise = null;
      });

    return refreshPromise;
  }, [setOpenSessionExpiredModal]);

  return refresh;
};

export default useRefreshToken;
